import { Link } from 'react-router-dom'
import { memo } from 'react'
import { DebugToggle } from '../../utils/debugWrapper'

const AdminHeader = memo(function AdminHeader() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <Link 
            to="/admin" 
            className="inline-flex items-center space-x-3 hover:opacity-80 transition-opacity"
          >
            <img 
              src="/logo.png" 
              alt="TrckIt Logo" 
              className="w-10 h-10"
            />
            <div>
              <h1 className="text-xl font-bold text-gray-900">TrckIt Admin</h1>
              <p className="text-xs text-gray-500">Management Dashboard</p>
            </div>
          </Link>
          
          {/* Debug Toggle - Only visible when VITE_DEBUG_MODE is enabled */}
          <DebugToggle showSelector={true} />
        </div>
      </div>
    </header>
  )
})

export default AdminHeader
